// CSV bulk-import Module — entry point.
// Sub-commit 4: open() is now a real flow — file pick → parse → preview first
// rows. Mapping, validation, and submit land in later sub-commits. The actual
// multi-step orchestration lives in flow.js; this file just wires the public
// surface.

import { injectCsvStyles } from './styles.js';
import { parseCsvFile, MAX_FILE_BYTES } from './parse.js';
import { openImportFlow } from './flow.js';

export function initCsvImport() {
  injectCsvStyles();
  console.log('[Huddledin] CSV import module initialized');
}

// Public entry — called by the "+ Import from CSV" menu item in
// _renderSpecDtPatientsPage. Delegates to flow.js so this file stays a thin
// registration surface.
function open() {
  openImportFlow();
}

// Mirror reports/index.js: register the module's public API at the bottom
// of this file (NOT from app.js). Keeps the module's surface self-contained.
// Expose parseCsvFile + MAX_FILE_BYTES so future sub-commits / debugging can
// reach them without a separate import.
window.HUD_CSV_IMPORT = {
  initCsvImport,
  open,
  parseCsvFile,
  MAX_FILE_BYTES,
};
